const pgcetmbaEnglishLanguage = [
  {
    id: 61,
    question: "Statements: All managers are leaders. All leaders are decision-makers. Conclusions: I. All managers are decision-makers. II. Some decision-makers are managers.",
    options: ["A. Only I follows", "B. Only II follows", "C. Both I and II follow", "D. Neither follows"],
    answer: "C"
  },
  {
    id: 62,
    question: "In a certain code, MARKET is written as NBSLFU. How is BUDGET written in the same code?",
    options: ["A. CVEHFU", "B. CVEHFV", "C. CVFHFU", "D. BVEHFU"],
    answer: "A"
  },
  {
    id: 63,
    question: "Find the next term in the series: 4, 9, 19, 39, 79, ?",
    options: ["A. 149", "B. 159", "C. 169", "D. 139"],
    answer: "B"
  },
  {
    id: 64,
    question: "A is the son of B. C is the mother of A. D is the brother of C. How is D related to B?",
    options: ["A. Brother-in-law", "B. Father", "C. Uncle", "D. Cannot be determined"],
    answer: "A"
  },
  {
    id: 65,
    question: "Statement I: Prices of essential commodities have risen sharply this year. Statement II: The government has announced subsidies for essential commodities. Choose the appropriate relationship:",
    options: [
      "A. Statement I is the cause and Statement II is its effect",
      "B. Statement II is the cause and Statement I is its effect",
      "C. Both statements are independent causes",
      "D. Both statements are independent effects"
    ],
    answer: "A"
  },
  {
    id: 66,
    question: "Find the odd one out:",
    options: ["A. Copper", "B. Iron", "C. Aluminium", "D. Oxygen"],
    answer: "D"
  },
  {
    id: 67,
    question: "A statement is followed by two arguments. Decide which is strong and which is weak. Statement: Should all companies be required to disclose their carbon emissions publicly? I. Yes, this promotes transparency and accountability toward environmental goals. II. No, companies should not have to disclose anything to anyone.",
    options: ["A. Only Argument I is strong", "B. Only Argument II is strong", "C. Both I and II are strong", "D. Neither I nor II is strong"],
    answer: "A"
  },
  {
    id: 68,
    question: "In a row of 50 employees, Priya is 18th from the left. If she is shifted 6 places to the left, what is her new position from the right end?",
    options: ["A. 37", "B. 38", "C. 39", "D. 36"],
    answer: "C"
  },
  {
    id: 69,
    question: "Pointing to a photograph, Meena said, \"He is the son of the only son of my grandfather.\" How is the man in the photograph related to Meena?",
    options: ["A. Brother", "B. Cousin", "C. Father", "D. Uncle"],
    answer: "A"
  },
  {
    id: 70,
    question: "Find the missing number: 3, 7, 15, 31, 63, ?",
    options: ["A. 125", "B. 127", "C. 129", "D. 131"],
    answer: "B"
  },
  {
    id: 71,
    question: "Which of the following words will come last in the dictionary?",
    options: ["A. Deliberate", "B. Delicate", "C. Delegate", "D. Deliver"],
    answer: "D"
  },
  {
    id: 72,
    question: "A cube is painted blue on all faces and cut into 64 equal smaller cubes. How many small cubes have exactly one face painted?",
    options: ["A. 16", "B. 24", "C. 8", "D. 32"],
    answer: "B"
  },
  {
    id: 73,
    question: "If the first day of a month is a Wednesday, what day will fall on the 22nd of that month?",
    options: ["A. Tuesday", "B. Wednesday", "C. Thursday", "D. Friday"],
    answer: "B"
  },
  {
    id: 74,
    question: "Complete the analogy: Author : Book :: Composer : ?",
    options: ["A. Orchestra", "B. Symphony", "C. Instrument", "D. Concert"],
    answer: "B"
  },
  {
    id: 75,
    question: "Assertion (A): Correlation between two variables does not imply causation. Reason (R): Two variables can be correlated due to a third, unobserved factor influencing both.",
    options: [
      "A. Both A and R are true and R is the correct explanation of A",
      "B. Both A and R are true but R is not the correct explanation of A",
      "C. A is true but R is false",
      "D. A is false but R is true"
    ],
    answer: "A"
  },
  {
    id: 76,
    question: "Five colleagues P, Q, R, S, T sit in a row facing north. R sits to the immediate left of Q. S sits at one of the extreme ends. P sits second to the right of S. T sits between S and P. Who sits at the other extreme end?",
    options: ["A. R", "B. Q", "C. T", "D. Cannot be determined"],
    answer: "B"
  },
  {
    id: 77,
    question: "Find the wrong term in the series: 2, 5, 11, 23, 46, 95",
    options: ["A. 5", "B. 11", "C. 23", "D. 46"],
    answer: "D"
  },
  {
    id: 78,
    question: "A person walks 8 km east, then turns left and walks 6 km, then turns left again and walks 8 km. How far is he from the starting point?",
    options: ["A. 6 km", "B. 8 km", "C. 10 km", "D. 14 km"],
    answer: "A"
  },
  {
    id: 79,
    question: "In a certain code, 'GARDEN' is written as '14 2 36 8 10 28', where each letter is assigned its position value doubled. Using the same logic, what is the code for 'HOUSE'?",
    options: ["A. 16 30 42 38 10", "B. 16 30 42 38 8", "C. 8 15 21 19 5", "D. 16 15 42 38 10"],
    answer: "A"
  },
  {
    id: 80,
    question: "Six people A, B, C, D, E, F are sitting around a circular table facing the centre. B sits second to the right of A. C sits immediately left of B. D sits opposite A. Who sits immediately right of D?",
    options: ["A. E or F (cannot be determined without more data)", "B. C", "C. B", "D. A"],
    answer: "A"
  }
];
 
export default pgcetmbaEnglishLanguage;